import {
  getData,
  multiMediaStateChange,
  removeMultiMedia,
  toggleUpdateAlert,
  toggleWarning,
  uploadMultiMedia,
  warningAction
} from "./alerts-api";

export const onGetData = (routeProps: any) => {
  return (dispatch: any, getState: any) => {
    getData({ routeProps, dispatch });
  };
};

export const onMultiMediaStateChange = (state: string, fileTypes: string) => {
  return (dispatch: any, getState: any) => {
    const alerts = getState().alerts;
    const { multiMedia } = alerts;
    multiMediaStateChange({ dispatch, multiMedia, state, fileTypes });
  };
};

export const onToggleUpdateAlert = (updateAlertState: string) => {
  return (dispatch: any, getState: any) => {
    const alerts = getState().alerts;
    const { listItem } = alerts;
    let warningContent;
    if (updateAlertState === "update") {
      warningContent = {
        header: "Update Alert",
        type: listItem.listData.type,
        title: "UPDATE: " + listItem.listData.title,
        action: "send update"
      };
    } else if (updateAlertState === "cancel") {
      warningContent = {
        header: "Cancel Alert",
        type: listItem.listData.type,
        title: "CANCELLED: " + listItem.listData.title,
        action: "send & cancel"
      };
    }
    toggleUpdateAlert({ dispatch, updateAlertState, warningContent });
  };
};

export const onToggleWarning = () => {
  return (dispatch: any, getState: any) => {
    const alerts = getState().alerts;
    const { warningActive } = alerts;
    toggleWarning({ dispatch, warningActive });
  };
};

export const onUploadMultiMedia = (files: any, id: string) => {
  return (dispatch: any, getState: any) => {
    const alerts = getState().alerts;
    const { multiMedia } = alerts;
    uploadMultiMedia({ dispatch, multiMedia, files, id });
  };
};

export const onRemoveMultiMedia = (name: string) => {
  return (dispatch: any, getState: any) => {
    const alerts = getState().alerts;
    const { multiMedia } = alerts;
    removeMultiMedia({ dispatch, multiMedia, name });
  };
};

export const onWarningAction = (action: boolean) => {
  return (dispatch: any, getState: any) => {
    const alerts = getState().alerts;
    const { warningActive } = alerts;
    warningAction({ dispatch, warningActive, action });
  };
};



// WEBPACK FOOTER //
// ./src/actions/alerts/alerts.tsx